import * as yup from "yup";

export const PASSWORD_MIN_LENGTH = 10;

export const password = yup
  .string()
  .required()
  .min(PASSWORD_MIN_LENGTH)
  .test(
    "letters-and-numbers",
    "Password must contain at least one letter and one number",
    (value) =>
      !value ||
      // TypeScript's ES5 target rejects Unicode property escape literals.
      // eslint-disable-next-line prefer-regex-literals
      (new RegExp("\\p{L}", "u").test(value) &&
        // eslint-disable-next-line prefer-regex-literals
        new RegExp("\\p{N}", "u").test(value)),
  )
  .label("Password");
